const state = {
    namespaced: true,
    state: {}
}

export default state